<!--
 * @Author: Gaho
 * @Date: 2024-05-30 18:06:00
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-22 17:36:16
 * @Description: 
-->
<template>
    <div v-if="isOpen" class="px-[10px] py-[15px] result justify-center items-center">
        <p class="text-[32px] mb-[6px]" style="text-shadow: 0 5px 12px rgba(0, 18, 81, 0.4)">
            {{ getFixed(mutipl) }}x
        </p>
        <div class="flex gap-2">
            <CurrentCoin />
            <span>{{ getFixed(expectedReward) }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    mutipl: {
        type: Number,
        required: true,
        default: 0,
    },
    expectedReward: {
        type: Number,
        required: true,
    },
    isOpen: {
        type: Boolean,
        required: true,
    }
});
</script>

<style scoped>
.result {
    left: 50%;
    top: 50%;
    position: absolute;
    background: linear-gradient(180deg, #0051cb 16.13%, #489cff 83.87%);
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    height: 100px;
    justify-content: center;
    opacity: 1;
    overflow: hidden;
    padding: 15px 10px;
    font-weight: 600;
    transform: translate(-50%, -50%);
    transition: all 0.3s;
    width: 200px;
    z-index: 5;
}
.result::before {
    position: absolute;
    animation: spin 24s linear infinite;
    background-image: url('../img/line-bg.webp');
    background-size: cover;
    background-repeat: no-repeat;
    content: '';
    height: 488px;
    opacity: 0.3;
    left: -50%;
    top: -50%;
    transform: translate(-50%, -50%);

    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    width: 488px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
